import script from "./LeadTable.vue?vue&type=script&setup=true&lang=js"
export * from "./LeadTable.vue?vue&type=script&setup=true&lang=js"

import "./LeadTable.vue?vue&type=style&index=0&id=4616cbad&scoped=true&lang=css"

import exportComponent from "/builds/izee/leadservice/lead-admin-tool/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4616cbad"]])

export default __exports__